import React from 'react';
import { createPortal } from 'react-dom';

import { getToastLayerHost } from './toast-layer-host';

interface ToastLayerProps {
  children: React.ReactNode;
}

/**
 * Рендерит тосты в узел, который `UDModal` переносит в открытое окно (`toast-layer-host.ts`).
 * Портал сохраняет контекст: тост со ссылкой по-прежнему видит роутер.
 */
export function ToastLayer({ children }: ToastLayerProps) {
  return createPortal(children, getToastLayerHost());
}
